import type {ReactElement} from 'react';
import React from 'react';
import {getCurrentPageBackground} from '@Components/poster-editor/poster-editor-reducer';
import {BaseTransparencyOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-transparency-option';
import {useAppSelector} from '@/hooks';
import {BackgroundTypeName} from "@PosterWhiteboard/page/background/background.types";

const transparencyStates = {
  DISABLED: 'disabled',
  ON: 'on',
  OFF: 'off',
};

export function ImageBgTransparencyOption(): ReactElement<any> | null {
  if (window.posterEditor?.whiteboard?.isVideo()) {
    return null;
  }

  const currentPageBackground = useAppSelector(getCurrentPageBackground);

  if (!currentPageBackground) {
    return null;
  }

  if (currentPageBackground.details.type !== BackgroundTypeName.IMAGE) {
    return null;
  }

  const imageDetails = currentPageBackground.details;

  if (imageDetails.transparency === transparencyStates.DISABLED) {
    return null;
  }

  const onToggleOption = (): void => {
    const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
    if (!currentPage) {
      return;
    }

    const currentTransparency = imageDetails.transparency;

    if (currentTransparency !== transparencyStates.DISABLED) {
      void currentPage.background.updateFromObject({
        details: {
          transparency: currentTransparency === transparencyStates.ON ? transparencyStates.OFF : transparencyStates.ON,
        },
      });
    }
  };

  const isTransparencyOptionDisabled = !(
    imageDetails.hashedFilename && imageDetails.fileExtension
  );

  return (
    <BaseTransparencyOption
      isChecked={imageDetails.transparency === transparencyStates.ON}
      isDisabled={isTransparencyOptionDisabled}
      onToggleOption={onToggleOption}
    />
  );
}
